import * as React from 'react'
require('../base.module.scss')
import { Button } from '../Button/Button'
import * as cn from 'classnames'
import * as st from './Pagination.module.scss'

export type PaginatorNumberProps = {
    type: 'PaginatorPageNo'
    text: string
    href?: string
    title: string
    isOptional?: boolean
}
const PaginatorNumber = ({
    href,
    text,
    title,
    isOptional,
}: PaginatorNumberProps) => (
    <li>
        <Button
            href={href || '#'}
            className={cn({ [st.hideOnSmall]: isOptional })}
            disabled={!href}
        >
            <span>{text}</span>
            <span className={st.a11yText}>{title}</span>
        </Button>
    </li>
)

export type PaginatorPreviousProps = {
    type: 'PaginatorPrevious'
    href: string
    title: string
}
const PaginatorPrevious = ({ href, title }: PaginatorPreviousProps) => (
    <li>
        <Button href={href}>
            &nbsp;
            <span className={st.arrow}>&#x25C4;</span>
            <span className={st.a11yText}>{title}</span>
        </Button>
    </li>
)

export type PaginatorNextProps = { type: 'PaginatorNext'; href: string; title: string }
const PaginatorNext = ({ href, title }: PaginatorNextProps) => (
    <li>
        <Button href={href}>
            &nbsp;
            <span className={st.arrow}>&#x25BA;</span>
            <span className={st.a11yText}>{title}</span>
        </Button>
    </li>
)

export type PaginatorGapProps = { type: 'PaginatorGap' }
const PaginatorGap = () => (
    <li>
        <Button
            href="#"
            disabled={true}
            className={st.ellipsis}
            aria-hidden="true"
            role="presentation"
            tabIndex="-1"
        >
            <span>&hellip;</span>
        </Button>
    </li>
)

export type PaginatorProps =
    | PaginatorNumberProps
    | PaginatorNextProps
    | PaginatorPreviousProps
    | PaginatorGapProps

const Paginator = (props: { paginator?: PaginatorProps[] }) => {

    if (!(props && props.paginator)) {
        return null
    }
    const pagination = props.paginator.map(paginator => {
        switch (paginator.type) {
            case 'PaginatorPrevious':
                return <PaginatorPrevious {...paginator} key={paginator.type} />
            case 'PaginatorNext':
                return <PaginatorNext {...paginator} key={paginator.type} />
            case 'PaginatorGap':
                return <PaginatorGap key="PaginatorGap" />
            default:
                return (
                    <PaginatorNumber
                        {...paginator}
                        key={paginator.text + paginator.type}
                    />
                )
        }
    })
    return <ol className={st.pagination}>{pagination}</ol>
}

export type PaginationProps = {
    paginator?: PaginatorProps[]
}
export const Pagination: React.ComponentType<PaginationProps> = ({ paginator }) => (
    <Paginator paginator={paginator} />
)

// Add displayName to preserve the component name on snapshot testing
Pagination.displayName = 'Pagination'
